// extracted by mini-css-extract-plugin
export default {"chatBotIcon":"MessageAuthor_chatBotIcon__HOl9N"};